<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                @if (form) {
                    <app-reactive-form-builder
                        #builderRef
                        (stableValueChanges)="stableValueChanges($event)"
                        (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
                        (goBack)="goBack()"
                        [form]="form.formFields"
                        [id]="reactiveFormRecordId"
                        [request]="request"
                        [getRequest]="getRequest">
                    </app-reactive-form-builder>
                }
            </div>
        </div>
    </div>
</p-panel>
